import { objectToQueryParams } from 'src/utils';

import messages from './messages';

const PRODUCT_STATUS_COMPLETED = 'Design Complete';
const PRODUCT_STATUS_PENDING = 'Design Incomplete';
const PRODUCT_STATUS_REJECTED = 'Design Rejected';

const getProductListConfig = (payload) => {
  const url = '/mcp/custom-designs/by-category-format';
  const { pagination, customProductCategory, productCategoryFormat } =
    payload || {};

  const paginationConfig = pagination
    ? {
        pageNumber: pagination?.currentPage,
        pageSize: pagination?.pageInterval,
      }
    : {};

  const queryParams = objectToQueryParams({
    ...paginationConfig,
    customProductCategory,
    productCategoryFormat,
  });

  return {
    url: `${url}${queryParams}`,
    dataPath: ['customDesigns'],
  };
};

const getProductStatusMessage = (status) => {
  if (status === PRODUCT_STATUS_COMPLETED) {
    return messages.productCompleted;
  }

  return messages.productPending;
};

export default class Product {
  static NAME = 'custom_design';

  static STATUS_COMPLETED = PRODUCT_STATUS_COMPLETED;

  static STATUS_PENDING = PRODUCT_STATUS_PENDING;

  static STATUS_REJECTED = PRODUCT_STATUS_REJECTED;

  static getListConfig = getProductListConfig;

  static getDeleteConfig = () => ({ url: '/mcp/custom-designs/delete' });

  static getStatusMessage = getProductStatusMessage;

  constructor(product) {
    this.id = product.workspaceId;
    this.name = product.name;
    this.description = product.description;
    this.type = product.itemType;
    this.status = product.status;
    this.lastModified = product.lastModified;
    this.detailsLink = product.productLink;
    this.canExport = product.canExportDesign;
    this.batchId = product.batchId;
    this.customProductCategory = product.customProductCategory;
    this.productCategoryFormat = product.productCategoryFormat;
  }

  getDetailsLink() {
    return '';
  }
}
